import CryptoJS from 'crypto-js';
// import Base64 from 'crypto-js/enc-base64'
// import Utf8 from 'crypto-js/enc-utf8'
import { sige_app_key } from './const-key';

const keyHex = CryptoJS.enc.Utf8.parse(sige_app_key);

// 加密
const encryptDES = (message: string) => {
  if (message) {
    let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString()
  } else {
    return '';
  }
};

// 解密
const decryptDES = (ciphertext: string) => {
  if (ciphertext) {
    //{ciphertext: CryptoJS.enc.Base64.parse(ciphertext)}
    var decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } else {
    return '';
  }
};

const base64Encode = (message: string) => {
  var wordArray = CryptoJS.enc.Utf8.parse(message);
  var base64 = CryptoJS.enc.Base64.stringify(wordArray);
  return base64
}

const base64Decode = (message: string) => {
  var parsedWordArray = CryptoJS.enc.Base64.parse(message);
  var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8);
  return parsedStr  
}

// 从query中获取sign 并解析成json对象
const signToJson = (sign: string) => {
  if (sign) {
    const signDecode = decodeURIComponent(sign)
    const desDecode = decryptDES(signDecode)
    const base64Str = base64Decode(desDecode)
    console.log(base64Str, 'base64Str')
    return JSON.parse(base64Str)
  } else {
    return null
  }
}

export {
  encryptDES,
  decryptDES,
  base64Decode,
  base64Encode,
  signToJson
}